// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"349":"14578a70","892":"14578a70"}[chunkId] + ".chunk.css";
};